<template>
  <v-container>
    <div class="admin_top">
      <div class="header">
        <img src="assets/logo_2nd_tool.png" style="height: 50px;margin-right: 20px;">
        <h1 style="text-align:left;font-size: 43px;margin-bottom: 0px;">システム管理者ページ</h1>
        <div style="text-align: right; float: right; position: absolute; right: 3%;">
          <div class="header-info">
            <p style="font-size:20px;margin-top: 13px;margin-right: 20px;">ユーザー名: {{ $store.state.user.name }}</p>
            <button class="btn btn-light" type="button" @click="logout">ログアウト</button>
            <button class="btn btn-success" type="button"  @click="$router.push('/createuser');"><span>新規作成</span></button>
          </div>
        </div>
      </div>

      <div class="content" style="padding: 3%;background: #e3e2dd; height: 92%;">
				<app-card
					:fullBlock="true"
					colClasses="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
				>
					<v-card-title>契約者一覧
						<v-spacer></v-spacer>
						<v-text-field
							label="検索"
							single-line
							hide-details
							v-model="search"
              row-style-class="table-row"
						>
						</v-text-field>
					</v-card-title>
					<v-data-table
						v-bind:headers="headers"
						v-bind:items="users"
						v-bind:search="search"
					>
						<template v-slot:item.action="{ item }">
							<v-btn small color="primary" @click="$router.push('/edituser/' + item.id);">編集</v-btn>
							<v-btn small color="error" @click.stop="userStop(item.id)">
                <span v-if="item.stopF">稼働</span>
                <span v-else>停止</span>
              </v-btn>
						</template>
					</v-data-table>
				</app-card>
      </div>
    </div>
    <!-- エラーモーダル -->
    <modal :name="errorModalName">
        <div class="modal-header">
            エラー
        </div>
        <div class="modal-body">
        <p>{{ msg }}</p>
        <button type="button" class="btn btn-secondary" @click="$modal.hide(errorModalName)">閉じる</button>
    </div>  
    </modal>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      users: [],
      errorModalName: 'error_modal',
      msg: '',
      plans: [
        "BASIC",
        "PLEMIUM",
        "PRO"
      ],
      headers: [
        { text: '利用開始日', align: "left", value: "createdAt" },
        { text: "契約者名", align: "left", value: "company" },
        { text: "登録名", align: "left", value: "name" },
        { text: "ユーザーID", align: "left", value: "userId" },
        { text: "顧客No", align: "left", value: "clientId" },
        { text: "契約プラン", align: "left", value: "plan" },
        { text: "状態", align: "left", value: "stopF" },
        { text: '操作', sortable: false, value: 'action' }
      ],
    }
  },
  methods: {
    fetchUsers() {
      this.users = [];
      this.$axios.get('/users/authId/' + this.$store.state.user.id)
        .then(res => {
          let users = res.data.users;
          if (users && users.length > 0) {
            users.forEach(user => {
              const fixedUser = this.adjustUser(user);
              fixedUser.createdAt = (fixedUser.createdAt != 0) ? this.getTimeString(fixedUser.createdAt) : '未入力';
              this.users.push(fixedUser);
            })
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },
    userStop(userId) {
      this.users.forEach(user => {
        if (user.id == userId) {
          user.stopF = !user.stopF;
          user = this.adjustUser(user);
          this.$axios.post('/editUser/' + JSON.stringify(user))
            .then((res) => {
                // メッセージがある場合は表示のみ行う
                if (res.data.msg) {
                    this.msg = res.data.msg;
                    this.$modal.show(this.errorModalName);
                    return;
                }
            })
            .catch((err) => {
                console.log(err)
            });
        }
      });
    },
    getTimeString(timestamp) {
      const date = new Date(timestamp);
      return date.getFullYear() + '年' + date.getMonth() + '月' + date.getDay() + '日';
    }
  },
  created: function () {
    this.existUser();
    this.fetchUsers()
  }
}
</script>

<style scope>
.container {
  max-width: 100%!important;
  padding: 0px;
  height: 100%;
}

.header {
  background:#a3d4c5;
  display: flex;
  padding: 22px;
  padding-left: 3%;
  padding-right: 3%;  
  color: white;
}

.header-info {
  display: flex;
  color: black;
}

.admin_top {
  height: 100%;
}

.admin_top button {
  margin-left:10px;
  margin-bottom:10px;
}
.admin_top button span{

}
.top_button{
  width:100%;
  text-align:right;
}

.table-row{
  
}
</style>
